import React, { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";

interface OptimizationHistoryAutocompleteProps {
  history: string[];
  selectedName: string;
  loading: boolean;
  onSelectedNameChange: (name: string) => Promise<void>;
}

export const OptimizationHistoryAutocomplete: React.FC<OptimizationHistoryAutocompleteProps> = ({
  history,
  selectedName,
  loading,
  onSelectedNameChange,
}) => {
  const options = useMemo(() => {
    if (!selectedName || history.includes(selectedName)) return history;
    return [selectedName, ...history];
  }, [history, selectedName]);

  const value = selectedName || undefined;

  return (
    <Autocomplete
      size="small"
      disableClearable
      options={options}
      value={value}
      loading={loading}
      onChange={(_, nextValue) => {
        if (!nextValue) return;
        void onSelectedNameChange(nextValue);
      }}
      noOptionsText={loading ? "Loading..." : "No study history"}
      renderInput={(params) => (
        <TextField
          {...params}
          label="select study name"
          InputLabelProps={{
            ...params.InputLabelProps,
            sx: { color: "#f0f0f0", fontSize: "12px" },
          }}
        />
      )}
      sx={{
        width: "100%",
        ".MuiInputBase-root": {
          color: "#f0f0f0",
          fontSize: "12px",
          backgroundColor: "#404040",
          borderRadius: 1,
        },
        ".MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(255, 255, 255, 0.23)",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(255, 255, 255, 0.4)",
        },
        ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#f0f0f0",
        },
        ".MuiSvgIcon-root": {
          color: "#f0f0f0",
        },
      }}
    />
  );
};
